export function ProgressBar({ totalWeight }) {
  return (
    <div className="mt-6 flex items-center space-x-4">
      <div className="flex-1 bg-gray-100 rounded-full h-3 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-blue-500 to-emerald-500 transition-all duration-500"
          style={{ width: `${totalWeight}%` }}
        />
      </div>
      <span className="text-sm font-semibold text-gray-700">
        {totalWeight}% Total Weight
      </span>
    </div>
  );
}